// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"4792403b","593":"c209a686"}[chunkId] + ".chunk.js";
};